import {usePaging} from "@/modules/reader/book/paging";
import AbstractAnnotations from "@/modules/reader/annotations/AbstractAnnotations";

class ToggleAllHintsAnnotation extends AbstractAnnotations{

    static get TYPE() {
        return "toggleHints"
    }

    constructor(builder) {

        super();
        const { pageState, setCurrentPage} = usePaging();
        this.annotations.domPos = builder.domPos;

        if (!this.annotationTypes.includes( ToggleAllHintsAnnotation.TYPE)) {
            this.annotationTypes.push(ToggleAllHintsAnnotation.TYPE);
        }

        this.annotations["isToggleAllHintsBtn"] = true;

        for (let [key,value] of Object.entries(builder.meta)) {

            /*
            let targetRectIds = value.split(",").map(el=>{
                return `rect_${el}`;
            })*/

            if (key === "ids") {
                let targetRectIds = value.split(",");
                super.setAnnotations({[key]:targetRectIds});
            }
            else if (key === "icon") {
                super.setAnnotations({"iconSrc" :value});
            }
            else if (key === "t") {
                super.setAnnotations({[key]: parseInt(value)});
            }
            else if (key === "hide") {
                if (value === "1") {
                    super.setAnnotations({[key]: parseInt(value)});
                }
            }
        }

    }

}

export default ToggleAllHintsAnnotation